import { gql } from '@parkchirp/api-client';

export const GET_ACCOUNT_HISTORY_V2 = gql`
    query getAccountHistory(
        $subscriptionId: String!
        $limit: Int
        $offset: Int
        $order: SortOrder
        $filters: [Filter]
        $tenantSubscriptionId: String
    ) {
        getAccountHistory(
            subscriptionId: $subscriptionId
            limit: $limit
            offset: $offset
            order: $order
            filters: $filters
            tenantSubscriptionId: $tenantSubscriptionId
        ) {
            data {
                accountHistoryType
                applicationDate
                invoiceReadableId
                creditReadableId
                creditId
                invoiceId
                amount
                subscriptionId
                createdAt
                timezone
                paymentMetaId
                paymentGroupId
                dueOn
                paymentType
                creditAmount
                subId
            }
            aging {
              current
              days1to30
              days31to60
              days61to90
              days91Plus
              totalLate
            }
        }
    }
`;

export const GET_ACCOUNT_HISTORY_COUNT_V2 = gql`
    query getAccountHistoryCount(
        $subscriptionId: String!
        $filters: [Filter]
        $tenantSubscriptionId: String
    ) {
        getAccountHistoryCount(
            subscriptionId: $subscriptionId
            filters: $filters
            tenantSubscriptionId: $tenantSubscriptionId
        ) {
             total
        }
    }
`;

export const GET_ACCOUNT_HISTORY_BALANCES_V2 = gql`
    query getAccountHistoryBalances(
        $subscriptionId: String!
        $tenantSubscriptionId: String
    ) {
        getAccountHistoryBalances(
            subscriptionId: $subscriptionId
            tenantSubscriptionId: $tenantSubscriptionId
        ) {
            totalInvoiceBalance
            totalCreditBalance
        }
    }
`;

export const ADD_SUBSCRIPTION_DOCUMENTS = gql`
  mutation addSubscriptionDocuments(
    $facilityId: String!,
    $organizationId: Int!
    $subscriptionId: String!,
    $files: [FileInput]
  ) {
    addSubscriptionDocuments(
      facilityId: $facilityId,
      organizationId: $organizationId,
      subscriptionId: $subscriptionId,
      files: $files
    ) {
        id,
        createdAt,
        fileName,
        bucketPath
    }
  }
`;

export const GET_USER_FOR_EMAIL = gql`
    query getUserForEmail(
      $email: String!,
    ) {
      getUserForEmail(email: $email) {
        cognitoSub,
        wordpressUserId,
      }
    }
`;

export const GET_SUBSCRIPTION_TAX_EXEMPT = gql`
  query getSubscription(
    $accountId: String
  ) {
    getSubscription(
      accountId: $accountId
    ) {
        id
        accountId
        subscriptionName
        taxExempt
        billingProfile {
          facilityId
          facility {
            facilityNumber
            facilityName
            timezone
          }
        }
        status
        payor {
          readableId
        }
      }
  }
`;

export const GET_SUBSCRIPTION = gql`
  query getSubscription(
    $accountId: String
    $subscription_id: String
    $tenantSubscriptionId: String
  ) {
    getSubscription(
      accountId: $accountId
      subscription_id: $subscription_id
      tenantSubscriptionId: $tenantSubscriptionId
    ) {
        payor {
          id
          readable_id
          type
          status
          contact_notes
          billing_firstname
          billing_lastname
          billing_phone
          billing_work_phone
          billing_email
          billing_emails {
              id
              payor_id
              email
          }
          billing_street
          billingAddressStreet2
          billing_city
          billing_state
          billing_zip
          info_name
          info_attn
          info_street
          info_city
          info_state
          info_zip
          cognito_sub
          wordpress_user_id
      }
      auto_pay
      account_id
      subscription_name
      status
      subscription_invoice_notes
      id
      account_id
      mail_invoices
      email_invoices
      tax_exempt
      autoInvoiceSetting
      autoApplyCredits
      numberOfParkingSpaces
      lateFees
      auto_pay
      billing_profile {
        id
        facility_id
        name
        validation_only
        facility {
          facility_name
          facility_number
        }
        facilitySettings {
          facility_id
          admin_process_payments
          manage_recurring_payments
          edit_payment_options
          use_ach
          use_credit_card
        }
      }
    }
  }
`;

export const GET_SUBSCRIPTION_V2 = gql`
  query getSubscriptionById(
    $subscriptionId: String!
    $facilityId: String
  ) {
    getSubscriptionById(
      subscriptionId: $subscriptionId
      facilityId: $facilityId
    ) {
      accountId
      accessSystemMeta
      autoApplyCredits
      autoInvoiceSetting
      creditCardFees
      defaultInvoiceBillingProfileId
      emailInvoices
      status
      id
      subscriptionSupportingDocuments {
        id
        fileName
        bucketPath
        createdAt
      }
      subscriptionInvoiceNotes
      lateFees
      mailInvoiceFees
      mailInvoices
      subscriptionName
      transactionFees
      taxExempt
      manualTaxExemptions { tax1 tax2 tax3 tax4 }
      billingProfile {
        name
        facilityId
        facility {
          organizationId
          facilityName
          facilityNumber
        }
      }
      manualInvoiceBillingProfile {
        id
        profileName
        dueDay
        billingDay
        billingDayInArrears
        dueDayInArrears
      }
      payor {
        billingFirstName
        billingLastName
        billingPhone
        billingCountryCode
        billingWorkPhone
        billingWorkCountryCode
        billingEmail
        billingEmails {
          id
          email
        }
        billingStreet
        billingAddressStreet2
        billingCity
        billingState
        billingZip
        cognitoSub
        contactNotes
        id
        infoAttn
        infoName
        infoStreet
        infoCity
        infoState
        infoZip
        readableId
        type
      }
    }
  }
`;

export const GET_SUBSCRIPTION_INVOICE_TEMPLATES = gql`
query getSubscriptionInvoiceTemplates($subscriptionId: String!) {
  getSubscriptionInvoiceTemplates(subscriptionId: $subscriptionId) {
    id
    invoiceType
    templateName
  } 
}
`;

export const GET_ALL_INVOICE_TEMPLATES = gql`
  query getAllInvoiceTemplates {
    getAllInvoiceTemplates {
      id
      invoiceType
      templateName
    } 
  }
`;

export const CREATE_SUBSCRIPTION_INVOICE_TEMPLATES = gql`
    mutation createSubscriptionInvoiceTemplates (
        $subscriptionId: String!
        $invoiceTemplateIds: [Int]!
        $facilityId: String!
    ) {
      createSubscriptionInvoiceTemplates(
        subscriptionId: $subscriptionId
        invoiceTemplateIds: $invoiceTemplateIds
        facilityId: $facilityId
        )
    }
`;

export const GET_SUBSCRIPTION_BILLING_PROFILE_DETAILS = gql`
  query getSubscription(
    $accountId: String
    $subscriptionId: String
    $tenantSubscriptionId: String
  ) {
    getSubscription(
      accountId: $accountId
      subscriptionId: $subscriptionId
      tenantSubscriptionId: $tenantSubscriptionId
    ) {
      tenantEnforceTermination
      billingProfile {
        terminationNoticeDay
        terminationRule
        billingDay
      }
    }
  }
`;

export const GET_TENANT_ENABLED_ACCESS_DEVICES = gql`
    query getTenantEnabledAccessDevices(
        $subscriptionId: String!
        $tenantSubscriptionId: String
    ) {
        getTenantEnabledAccessDevices(
            subscriptionId: $subscriptionId
            tenantSubscriptionId: $tenantSubscriptionId
        )
    }
`;

export const DELETE_FILE = gql`
    mutation deleteFile(
        $fileId: Int!
    ) {
        deleteFile(
            fileId: $fileId
        )
    }
`;

export const GET_SUBSCRIPTION_ACTIVITY_REPORT = gql`
  query getSubscriptionActivityReport(
    $facilityId: String!,
    $accountId: Int,
    $subscriptionName: String,
    $startMonth: Int,
    $startYear: Int,
    $endMonth: Int,
    $endYear: Int,
    $isSummary: Boolean,
    $showOutstandingBalances: Boolean,
    $reportType: ReportType!
  ) {
    getSubscriptionActivityReport(
        facilityId: $facilityId,
        accountId: $accountId,
        subscriptionName: $subscriptionName,
        startMonth: $startMonth,
        startYear: $startYear,
        endMonth: $endMonth,
        endYear: $endYear,
        isSummary: $isSummary,
        showOutstandingBalances: $showOutstandingBalances,
        reportType: $reportType
    ) {
      url
    }
  }
`;

export const GET_LEASE_INITIAL_INVOICE_MONTHS = gql`
  query getLeaseInitialInvoiceMonths(
    $subscriptionId: String!
  ) {
    getLeaseInitialInvoiceMonths(
      subscriptionId: $subscriptionId
    )
  }
`;

export const LIST_SUBSCRIPTIONS_V2 = gql`
  query listSubscriptions(
    $accountIds: [Int]
    $facilityId: String
    $subscriptionNames: [String]
    $tenantSubscriptionId: String
    ) {
      listSubscriptions(
        accountIds: $accountIds
        facilityId: $facilityId
        subscriptionNames: $subscriptionNames
        tenantSubscriptionId: $tenantSubscriptionId
      ) {
          accountId
          id
          subscriptionName
          billingProfile {
            id
            facility {
              id
            }
          }
          payor { 
            cognitoSub
        }
      }
    }
`;

export const LIST_TAX_EXEMPT_CERTIFICATES = gql`
  query listTaxExemptCertificates(
    $limit: Int!
    $offset: Int!
    $filters: [Filter]
    $order: SortOrder
  ) {
    listTaxExemptCertificates(
      limit: $limit
      offset: $offset
      filters: $filters
      order: $order
    ) {
      total
      taxExemptCertificates {
        id
        companyName
        issueDate
        issueState
        filePath
        expirationDate
        exemptionNumber
        organizationType
        createdAt
        subscriptionId
        subStatus
        accountId
        subscriptionName
        taxExempt
        billingProfileId
        billingProfileName
        facilityId
        facilityNumber
        facilityName
        organizationId
        timezone
        payorId
        subscriptionTaxExemptTaxes {
          taxNumber
          effectiveStartDate
          adjustmentDateType
        }
      }
    }
  }
`;

export const GET_TAX_EXEMPT_CERTIFICATES_CSV = gql`
      query getTaxExemptCertificatesCsv(
        $order: SortOrder,
        $filters: [Filter],
    ) {
        getTaxExemptCertificatesCsv(
            order: $order,
            filters: $filters
        ) {
            url
        }
    }
`;

export const SEARCH_BY_ACCOUNT_ID = gql`
      query getSubscriptionByAccountId(
        $accountId: Int!
    ) {
        getSubscriptionByAccountId(
            accountId: $accountId
        ) {
            id
            accountId
            subscriptionName
            billingProfile {
                facility {
                    id
                    facilityName
                    facilityNumber
                }
            }
        }
    }
`;

export const GET_SUBSCRIPTION_SETTINGS = gql`
  query getSubscriptionById(
    $subscriptionId: String!
  ) {
    getSubscriptionById(
      subscriptionId: $subscriptionId
    ) {
      accessSystemMeta
      achDisabled
      autoApplyCredits
      autoInvoiceSetting
      batchNewParkers
      autoPay
      creditCardFees
      lateFees
      mailInvoiceFees
      transactionFees
      vehicleSurchargeFees
      sendUnpaidInvoiceReminder
      sendBatchInvoiceOn
      allowCreditCardPayments
      recurringPaymentsSetting
      billingProfile {
        facility {
          integration
        }
      }
      manualInvoiceBillingProfile {
        profileName
        id
      }
    }
  }
`;

export const UPDATE_SUBSCRIPTION_RECURRING_PAYMENTS = gql`
  mutation updateSubscriptionRecurringPayments(
    $subscriptionId: String!,
    $subscription: UpdateSubscriptionInput!,
    $facilityId: String!,
    $isFromTenantPortal: Boolean
  ) {
      updateSubscriptionRecurringPayments(
        subscriptionId: $subscriptionId,
        subscription: $subscription,
        facilityId: $facilityId,
        isFromTenantPortal: $isFromTenantPortal
      ) {
        id  
    }
  }
`;

export const UPDATE_SUBSCRIPTION_SETTINGS = gql`
  mutation updateSubscriptionSettings(
    $subscriptionId: String!,
    $subscription: UpdateSubscriptionInput!,
    $facilityId: String!
  ) {
      updateSubscriptionSettings(
        subscriptionId: $subscriptionId,
        subscription: $subscription,
        facilityId: $facilityId
      ) {
        id  
    }
  }
`;

export const UPDATE_SUBSCRIPTION = gql`
  mutation updateSubscription(
    $facilityId: String!,
    $isFromTenantPortal: Boolean,
    $subscription: UpdateSubscriptionInput!,
    $subscriptionId: String!
  ) {
      updateSubscription(
        facilityId: $facilityId,
        isFromTenantPortal: $isFromTenantPortal,
        subscription: $subscription,
        subscriptionId: $subscriptionId
      ) {
        id  
    }
  }
`;
